export function replaceKeyWithName(match, whitespace, letter) {
    return `${whitespace}${letter.toUpperCase()}`;
}

export function navNode(nameOrConfigOrChildren?: string | object, childrenOrConfig?: object, children?: object) {
    let name: string;
    let config: object = {};

    if (children) {
        name = <string>nameOrConfigOrChildren;
        config = childrenOrConfig;
    } else {
        if (typeof nameOrConfigOrChildren === "string") {
            name = nameOrConfigOrChildren;
        }
        for (const arg of [nameOrConfigOrChildren, childrenOrConfig]) {
            if (arg) {
                if (Array.isArray(arg) || Object.keys(arg).some(k => (arg[k] as any).__isNavNode)) {
                    children = <object>arg;
                } else {
                    config = <object>arg;
                }
            }
        }
    }

    children = children || {};

    if (Array.isArray(children)) {
        children = children.reduce((obj, member) => {
            if (member.__isNavNode) {
                obj[member.path] = member;
            } else {
                obj[member] = navNode();
            }
            return obj;
        }, {});
    }

    for (const key of Object.keys(children)) {
        if (typeof children[key].name === "undefined") {
            children[key].name = key.replace(/-/g, " ")
                .replace(/(^|[\s])([\w])/g, replaceKeyWithName);
        }
    }

    return {
        ...config,
        __isNavNode: true,
        children,
        name,
    };
}
